import { BaseModel } from "../../model/shared/BaseModel";
import {
  CLIENT_MAPPING_URL,
  CLIENT_SEMG_URL,
  CLIENT_URL,
  DATA_QUALITY_URL,
  IMPORT_MAPPING_URL,
} from "../../utils/helpers/api.routes";
import { requests } from "../../utils/helpers/api.services";
import { IClient } from "../../model/authentification/IRegister";
import { IClientsDTO, IClientsQuery } from "../clients/dto/IClients";

export const ClientCustomService = {
  export: (params: any) => requests.post(`${CLIENT_SEMG_URL}export`, params),
  getAllSemgProducts: (params: any): Promise<BaseModel<any[]>> =>
    requests.get(`${CLIENT_SEMG_URL}product-list`, params),
  getSemgProduct: (id: any, variationId: any): any =>
    requests.get(`${CLIENT_SEMG_URL}product/${id}/${variationId}`),
  updateProductById: (id: number, params: any) =>
    requests.put(`${CLIENT_SEMG_URL}product/${id}`, params),
  updateProductAttributeById: (id: number, params: any) =>
    requests.put(`${CLIENT_SEMG_URL}product-attribute/${id}`, params),
  getSemgProductImages: (id: any, variationId: any): any =>
    requests.get(`${CLIENT_SEMG_URL}image/list/${id}/${variationId}`),
  updateProductImageLabelById: (id: any, variationId: number, params: any) =>
    requests.put(
      `${CLIENT_SEMG_URL}image/set-label/${id}/${variationId}`,
      params
    ),
  deleteImage: (id: any, variationId: number, params: any) =>
    requests.post(
      `${CLIENT_SEMG_URL}image/delete-image/${id}/${variationId}`,
      params
    ),
  setPositions: (id: any, variationId: number, params: any) =>
    requests.post(
      `${CLIENT_SEMG_URL}image/set-positions/${id}/${variationId}`,
      params
    ),

  uploadImages: (id: any, variationId: number, params: FormData) =>
    requests.post(
      `${CLIENT_SEMG_URL}image/upload-images/${id}/${variationId}`,
      params
    ),
  //   getImportMapping: (id: number): any =>
  //     requests.get(`${IMPORT_MAPPING_URL}client/${id}`),
  //   getClientById: (id: number) => requests.get(`${CLIENT_URL}/${id}`),
  //   updateClientById: (id: number, params: IClient) =>
  //     requests.put(`${CLIENT_URL}/${id}`, params),
  //   updateMappingImportClientById: (id: number, params: any) =>
  //     requests.put(`${IMPORT_MAPPING_URL}client/${id}`, params),
  //   deleteClientById: (id: number) => requests.delete(`${CLIENT_URL}/${id}`),
  //   saveDataQuality: (id: number, params: any) =>
  //     requests.put(`${DATA_QUALITY_URL}/${id}`, params),
  //   getDataQuality: (id: number): any =>
  //     requests.get(`${DATA_QUALITY_URL}/${id}`),
};
